import React, { useEffect, useState } from 'react';
import { Grid, Typography, Card, CardActionArea, CardContent, Button, makeStyles, Dialog, DialogActions, DialogTitle, DialogContent, CardMedia } from '@material-ui/core';
import digispelthumb from '../assets/img/DigiSpel.jpg'
import digitaalthumb from '../assets/img/DigiTaal_Thumbnail.jpg'
import digiskryfthumb from '../assets/img/DigiSkryf_Thumbnail.jpg'
import digispanpraatthumb from '../assets/img/DigiSpanpraat_Thumbnail.jpg'
import digikunsthumb from '../assets/img/DigiKuns_Thumbnail.jpg'
import digipraatthumb from '../assets/img/DigiPraat_Thumbnail.jpg'


const useStyles = makeStyles((theme) => ({
    paper: {
        width: 300,
        marginTop: '20%',
        marginLeft: 'auto',
        backgroundColor: theme.palette.background.paper,
        padding: theme.spacing(0, 0, 2),
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        position: 'absolute'
    },
    card: {
        width: 150,
        marginTop: '2%',
        marginLeft: '2%',
    },
    discard: {
        width: 150,
        marginTop: '2%',
        marginLeft: '2%',
        background: '#A9A9A9',
    },
    media: {
        height: '100%',
        paddingTop: '', // 16:9
    }
}));


const AllProjects = (props) => {
    const classes = useStyles();
    const [open, setOpen] = useState(false);
    const [modalContent, setModalContent] = useState("");
    const [modalLink, setModalLink] = useState("");
    const [admin, setAdmin] = useState("");
    const [isAdmin, setIsAdmin] = useState(false);


    const handleOpen = (e) => {
        setModalContent(e);
        setModalLink(e.toLowerCase());
        setOpen(true);

    };

    const handleClose = () => {
        setOpen(false);
    };

    useEffect(() =>
    {
        console.log("before POST:",props.userProf);
        fetch('authadmin',
            {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(props.userProf.userProfile)
            }).then((response) => response.json())
            .then((data) => setAdmin(data))

        
    }, [])

    useEffect(() => {
        //console.log("changed admin props:", admin);
        //console.log("view admin props:", admin.isAdmin);
        setIsAdmin(admin["isAdmin"]);

    }, [admin])

    useEffect(() => {
       // console.log('modal content', modalContent);
    }, [modalContent])



    return (
        <Grid container justify="center">
            <Grid item lg={12} sm={12}>
                <Grid container justify="center">
                    <Typography variant="h3">Kies 'n projek</Typography>
                </Grid>
            </Grid>
            <Grid item lg={12} sm={12}>
                <Grid container justify="center">
                    {isAdmin ?
                        <Card className={classes.card}>
                            <CardActionArea>
                                <CardContent onClick={() => props.history.push('datadashboard')}>
                                    <Typography gutterBottom variant="h5" component="h2">
                                        Data Dashboard
                                </Typography>
                                </CardContent>
                            </CardActionArea>
                        </Card>

                        :<div></div>

                    }

                    <Card className={classes.card}>
                        <CardActionArea>
                            <CardMedia
                                component="img"
                                alt="DigiSpel"
                                className={classes.media}
                                image={digikunsthumb}
                                title="DigiSpel"
                            />
                            <CardContent
                                onClick={() => { handleOpen("DigiKuns") }}>
                                <Typography gutterBottom variant="h5" component="h2">
                                    DigiKuns
                                </Typography>
                            </CardContent>
                        </CardActionArea>
                    </Card>
                    <Card className={classes.card}>
                        <CardActionArea>
                            <CardMedia
                                component="img"
                                alt="DigiSpel"
                                className={classes.media}
                                image={digipraatthumb}
                                title="DigiSpel"
                            />
                            <CardContent
                                onClick={() => { handleOpen("DigiPraat") }}>
                                <Typography gutterBottom variant="h5" component="h2">
                                    DigiPraat
                                </Typography>
                            </CardContent>
                        </CardActionArea>
                    </Card>
                    <Card className={classes.card}>
                        <CardActionArea>
                            <CardMedia
                                component="img"
                                alt="DigiSpel"
                                className={classes.media}
                                image={digiskryfthumb}
                                title="DigiSpel"
                            />
                            <CardContent
                                onClick={() => { handleOpen("DigiSkryf") }}>
                                <Typography gutterBottom variant="h5" component="h2">
                                    DigiSkryf
                                </Typography>
                            </CardContent>
                        </CardActionArea>
                    </Card>
                    <Card className={classes.card}>
                        <CardActionArea>
                            <CardMedia
                                component="img"
                                alt="DigiSpel"
                                className={classes.media}
                                image={digispanpraatthumb}
                                title="DigiSpel"
                            />
                            <CardContent
                                onClick={() => { handleOpen("DigiSpanpraat") }}>
                                <Typography gutterBottom variant="h5" component="h2">
                                    DigiSpanpraat
                                </Typography>
                            </CardContent>
                        </CardActionArea>
                    </Card>
                    <Card className={classes.card}>
                        <CardActionArea
                            onClick={() => { handleOpen("DigiSpel") }}
                        >
                            {/*DigiSpel inskrywings word gesluit 2020-10-08.  */}
                            <CardMedia
                                component="img"
                                alt="DigiSpel"
                                className={classes.media}
                                image={digispelthumb}
                                title="DigiSpel"
                            />
                            <CardContent>
                                <Typography gutterBottom variant="h5" component="h2">
                                    DigiSpel
                                </Typography>
                            </CardContent>
                        </CardActionArea>
                    </Card>
                    <Card className={classes.card}>
                        <CardActionArea>
                            <CardMedia
                                component="img"
                                alt="DigiSpel"
                                className={classes.media}
                                image={digitaalthumb}
                                title="DigiSpel"
                            />
                            <CardContent
                                 onClick={() => { handleOpen("DigiTaal") }}>
                                <Typography gutterBottom variant="h5" component="h2">
                                    DigiTaal
                                </Typography>
                            </CardContent>
                        </CardActionArea>
                    </Card>
                    <Card className={classes.card}>
                        <CardActionArea>
                            <CardContent
                                onClick={() => { handleOpen("Tienertoneel") }}>
                                <Typography gutterBottom variant="h5" component="h2">
                                    Tienertoneel
                                </Typography>
                            </CardContent>
                        </CardActionArea>
                    </Card>


                </Grid>
            </Grid>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">Klik op 'GAAN VOORT' om in te skryf vir '{modalContent}'</DialogTitle>
                <DialogContent>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        Gaan Terug
          </Button>
                    <Button onClick={() => { props.history.push(modalLink) }} color="primary" autoFocus>
                        Gaan Voort
          </Button>
                </DialogActions>
            </Dialog>        </Grid>

    )
}

export default AllProjects;


// WEBPACK FOOTER //
// ./src/components/AllProjects.js